import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 60000,
  withCredentials: true,
});

export const scoutQuickScan = async (form) => (await api.post('/scout/scan', form)).data;
export const scoutScanCandidate = async (candidateId) => (await api.post(`/scout/candidates/${candidateId}/scan`)).data;
export const getScoutCandidateScan = async (candidateId) => (await api.get(`/scout/candidates/${candidateId}`)).data;
export const scoutScanJob = async (jobId) => (await api.post(`/scout/jobs/${jobId}/scan`)).data;
export const scoutBulkCsv = async (form) => (await api.post('/scout/bulk', form)).data;
export const getScoutScans = async (params) => (await api.get('/scout/scans', { params })).data;
export const getScoutScan = async (scanId) => (await api.get(`/scout/scans/${scanId}`)).data;
export const rescanScoutScan = async (scanId) => (await api.post(`/scout/scans/${scanId}/rescan`)).data;
export const overrideScoutScan = async (scanId, reason) => (await api.post(`/scout/scans/${scanId}/override`, { reason })).data;
export const getScoutVendors = async (region) => (await api.get('/scout/vendors', { params: { region } })).data;
export const scoutTemplateUrl = `${process.env.REACT_APP_BACKEND_URL}/api/scout/csv-template`;
export const apiError = (e, fallback = 'Something went wrong') => e?.response?.data?.detail || fallback;
